import { buildExpressQuery } from '../queries/builders';

export const listGeofencesQuery = ({ type, ids, filterDeleted, filterParams }) => {
    const endpoint = '/geofence';
    const params = {};

    const validIds = ids ? ids.filter((id) => !!id) : [];

    if (type) {
        params.where = { ...params.where, type };
    }

    if (filterParams) {
        params.where = { ...params.where, ...filterParams };
    }

    if (validIds.length) {
        params.where = { ...params.where, user_id: { inq: validIds } };
    }

    if (filterDeleted) {
        params.where = { ...params.where, deleted_at: { eq: null } };
    }

    params.populate = {
        ...(validIds.length && { user_id: ['full_name', 'name', 'role'] }),
    };

    return buildExpressQuery(endpoint, { params });
};

export const addGeofenceQuery = ({ model }) => {
    const endpoint = '/geofence';
    const body = model;
    return buildExpressQuery(endpoint, { body });
};

export const editGeofenceQuery = ({ id, model }) => {
    const endpoint = `/geofence/${id}`;
    const body = model;
    return buildExpressQuery(endpoint, { body });
};

export const deleteGeofenceQuery = (id) => {
    const endpoint = `/geofence/${id}`;
    return buildExpressQuery(endpoint, {});
};
